import { Navigate, useSearchParams } from "react-router-dom";
import Login from "src/sites/Login";

const LoginRouteRedirector = ({ isAuthenticated }) => {
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect");

  if (isAuthenticated) {
    return (
      <Navigate
        to={`${process.env.REACT_APP_ROOT_SERVER_PATH}${
          redirect || "/paciente/reservas"
        }`}
        replace
      />
    );
  }

  return <Login />;
};

export default LoginRouteRedirector;